import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import axios from 'axios';

import './FileUpload.css';
import TrackPopUp from './TrackPopUp';
import Upload from './Upload';
// import trackAccess from '../../Data/track-access.json';
import Alert from '@mui/material/Alert';

// Add Modal for confirmation
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


export default function FileUpload() {

    const [trackAccess, setTtrackAccess] = useState();
    const [newTrackAccess, setNewTrackAccess] = useState();
    const [buttontracks, setButtonTracks] = useState();
    // let newTrackAccess;
    const [fetchError, setFetchError] = useState(false);

    // State for delete confirmation
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteDocId, setDeleteDocId] = useState(null);

    useEffect(() => {
        // axios.get("http://localhost:3021/track/getUsernames")
        axios.get("https://atci.lkm.qa.accenture.com/qa-apis/track/getUsernames")
            .then((res) => {
                setTtrackAccess(res.data);
                console.log(res.data, "resdataaaaa")
            })
            .catch((err) => {
                setFetchError(true);
                console.log(err)
            })
    }, [])

    const lowerize = obj =>
        Object.keys(obj).reduce((acc, k) => {
            acc[k.toLowerCase()] = obj[k];
            return acc;
        }, {});

    useEffect(() => {
        let techTrackAccess = trackAccess && lowerize(trackAccess?.["technology-wise-full-access"])
        setNewTrackAccess(techTrackAccess);
        // trackAccess && setTtrackAccess(...trackAccess, "technology-wise-full-access" = newTrackAccess);
        console.log(newTrackAccess, "newwwwwwww");
    }, [trackAccess]);

    const [file, setFile] = useState({ name: '' });
    const [documents, setDocuments] = useState([]);
    const [fileStatus, setFileStatus] = useState('');
    const [tableExtraCols, setTableExtraCols] = useState(false);
    const [btnPop, setBtnPop] = useState(false);

    let url = 'https://atci.lkm.qa.accenture.com/qa-apis/';

    let location = useLocation();
    let monthFolderPath = location.pathname.slice(8);
    let uploadPath = location.pathname.split('/');
    let archiveFolderPath = `${uploadPath[1]}/${uploadPath[2]}/${uploadPath[3]}/${uploadPath[4]}`;

    console.log(location, "location")
    console.log(uploadPath, "uploadPathhh")

    const { instance } = useMsal();

    let sno = 0;

    const activeAccount = instance.getActiveAccount();
    let ipsLoggedInEnterpriseId = '';
    if (activeAccount) {
        ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.email;
    }

    const getDocuments = () => {
        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3021';
        }
        axios.get(url,
            {
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(res => {
                setDocuments(res?.data?.results);
            })
            .catch(err => console.log(err));
    }

    const handleMoveArchive = (doc_id, archive_path) => {
        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3021/';
            alert('You are not allowed to move a file into archive.');
            return;
        }
        axios.post(`${url}${doc_id}`, {
            doc_path: archive_path
        },
            {
                headers: {
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                }
            })
            .then(res => {
                setTableExtraCols(false);
                getDocuments();
            })
            .catch(err => console.log(err))
    }

    const handleDownload = (doc_id, doc_name) => {
        if (process.env.NODE_ENV === 'development')
            url = 'http://localhost:3021/';
        axios({
            method: 'get',
            url: `${url}${doc_id}`,
            responseType: 'blob',
            headers: {
                'Authorization': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    doc_name,
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => console.log(err))
    }

    const handleDelete = (doc_id) => {
        setDeleteDocId(doc_id); // Set the document ID for confirmation
        setOpenDeleteDialog(true); // Open the delete confirmation popup
    }

    const confirmDelete = () => {
        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3021/';
            alert(`you are not allowed to delete a file from development environment.`);
            return;
        }
        axios.get(`${url}document/delete/${deleteDocId}`,
            {
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(res => {
                setOpenDeleteDialog(false); // Close the confirmation dialog
                getDocuments();
            })
            .catch(err => console.log(err))
    }

    const handleCancelDelete = () => {
        setOpenDeleteDialog(false); // Close the dialog if "No" is clicked
    }

    useEffect(() => {
        getDocuments();
    }, [])


    return (
        <div>
            <p className='track-file-upload-heading'>L&TT QA Artifacts</p>
            <div className='track-upload-file-container'>
                {/* {console.log(uploadPath[4],"upload 4 ki value")}
                {console.log(newTrackAccess?.[uploadPath[4]],"uploadddd4")}
                {console.log(newTrackAccess,"hahaaaaaa newTrackAccess")}
                {console.log(newTrackAccess?.[uploadPath[4]]?.includes(ipsLoggedInEnterpriseId), "new track inside return")} */}

                {/* {console.log(uploadPath[4], "uploadddPath444")}
                {console.log(ipsLoggedInEnterpriseId, "enterrrrrrr")} */}


                {(trackAccess?.['full-access'].includes(ipsLoggedInEnterpriseId)
                    || newTrackAccess?.[uploadPath[4]]?.includes(ipsLoggedInEnterpriseId)) ?
                    <>
                        <Upload archiveStatus={0} getAllDocuments={getDocuments} folderPath={monthFolderPath} disable="false" />
                        {/* <span className='track-technology-orText'>or</span>                
                        <TrackPopUp docId={0} setDocuments={setDocuments}/>                 */}
                        <hr className='track-upload-hr-line' />
                    </> :
                    <>
                        <Upload archiveStatus={0} getAllDocuments={getDocuments} folderPath={monthFolderPath} disable="true" />
                        <hr className='track-upload-hr-line' />
                    </>

                }
                <Link to={`/${archiveFolderPath}/archives`} className='track-file-archive-btn'>Go to Archive </Link>
            </div>
            <br />
            <br />
            {fetchError && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the LIS team for further assistance.</Alert>}
            <table className="track-technology">
                <tr>
                    <th>SL.#</th>
                    <th>File Name</th>
                    <th>Modified By</th>
                    <th>Actions</th>
                </tr>
                {sno === 0 && documents.map((document, index) => {
                    if (document.archived !== 1 && location.pathname.slice(8) === document.path) {
                        !tableExtraCols && setTableExtraCols(true);
                        let archivePath = document.path.split('/');
                        return <tr>
                            <td>{++sno}</td>
                            <td>{document.name}</td>
                            <td>{document.modified_by}</td>
                            <td>
                                <button className='track-technology-move' onClick={() => { handleDownload(document.id, document.name) }}>Download</button>
                                &nbsp;&nbsp;
                                <TrackPopUp docId={document.id} setDocuments={setDocuments} />
                                {/* {console.log(buttontracks, "button tracks")}
                                {console.log(trackAccess, "track access")}
                                {console.log(newTrackAccess, "new track access")} */}
                                {console.log(uploadPath[4], "upload pathhhhh")}
                                {(trackAccess?.['full-access']?.includes(ipsLoggedInEnterpriseId)
                                    || newTrackAccess?.[uploadPath[4]]?.includes(ipsLoggedInEnterpriseId)) && <>
                                        &nbsp;&nbsp;
                                        <button className='track-technology-move' onClick={() => { handleDelete(document.id) }}>Delete</button>
                                        &nbsp;&nbsp;
                                        <button className='track-technology-move' onClick={() => { handleMoveArchive(document.id, `${archivePath[0]}/${archivePath[1]}/${archivePath[2]}/archives`) }}>Move to Archive</button>
                                    </>}
                            </td>
                        </tr>
                    } else {
                        return '';
                    }
                })}
                {sno === 0 && <tr><td colSpan={4} className="track-technology-msg">No documents found</td></tr>}
            </table>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={openDeleteDialog}
                onClose={handleCancelDelete}
            >
                <DialogTitle >Confirm Deletion</DialogTitle>
                <DialogContent>
                    <p>Are you sure you want to delete this document?</p>
                </DialogContent>
                <DialogActions className="dialog-delete-confirm-buttons">
                    <button className="yes-btn" onClick={confirmDelete} color="secondary">
                        Yes
                    </button>
                    <button className="no-btn" onClick={handleCancelDelete} color="primary">
                        No
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    )
}